import CommonDatePicker from "@/common/elements/DatePicker";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import {
  StyledFlex,
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
} from "@/common/styles";
import {
  InmateDetailsTableContainer,
  TableHeader,
} from "../InmateDetails/styles";
import Button from "@/common/elements/Button";
import Table from "@/common/elements/Table";
import Modal from "@/common/elements/Modal";
import { useEffect, useState } from "react";
import {
  debounce,
  getOptionsFromRefList,
  hasCheckSecurity,
  isNonEmptyVariable,
} from "@/util/common_function";
import { useDispatch, useSelector } from "react-redux";
import { Form, Popconfirm } from "antd";
import dayjs from "dayjs";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import { v4 as uuidv4 } from "uuid";
import API_ENDPOINTS from "@/util/api";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";

const BoookingsReleaseInformation = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [releaseNotesForm] = Form.useForm();
  const [QForm] = Form.useForm();
  const [overrideDateTime, setOverrideDateTime] = useState(false);
  const currentUser = JSON.parse(localStorage.getItem("userDetails"));
  const [isDisabled, setIsDisabled] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const releaseNotesTable = {
    headers: [
      { key: "releaseNote", text: "Release Note" },
      { key: "cleared", text: "Cleared" },
      { key: "comments", text: "Comments" },
    ],
  };
  const QFormData = {
    releaseNote: "",
    comments: "",
  };

  const booking = useSelector((state) => state.bookings?.bookings);
  const { bookingsFieldsEnabled } = useSelector((state) => state?.bookings);
  // const [releaseNotesList, setReleaseNotesList] = useState(
  //   booking?.releaseNotes?.map((item) => {
  //     return { ...item };
  //   }) || []
  // );
  const [releaseNotesList, setReleaseNotesList] = useState([]);
  const [releaseNoteID, setReleaseNoteID] = useState();
  const [selectedReleaseNotes, setSelectedReleaseNotes] = useState({
    releaseNote: "",
    comments: "",
    cleared: false,
    clearanceNotes: "",
    clearanceDateTime: null,
    clearedByStaffID: "",
    releaseNoteID: "",
  });

  const [isQFormBtnEnable, setIsQFormBtnEnable] = useState(true);

  const [formData, setFormData] = useState(null);

  const [showAddModal, setShowAddModal] = useState(false);

  const fullSearch = useSelector(state => state.fullSearch);

  useEffect(() => {
    if (booking !== null) {
      let releaseDateTime = null;
      let usingCharges = false;
      let chargeCandidate;

      if (
        booking?.charges?.length > 0 &&
        !booking?.arrestReports?.[0]?.scheduledReleaseOverridden
      ) {
        chargeCandidate = booking?.charges?.find(
          (charge) =>
            charge.controllingCharge === true &&
            charge.sentenced === true &&
            isNonEmptyVariable(charge?.scheduledReleaseDate)
        );

        if (
          chargeCandidate &&
          isNonEmptyVariable(chargeCandidate?.scheduledReleaseDate)
        ) {
          releaseDateTime = dayjs(
            `${chargeCandidate?.scheduledReleaseDate} ${
              chargeCandidate?.scheduledReleaseTime || ""
            }`
          );
          usingCharges = true;
        }
      }

      if (!usingCharges && booking?.arrestReports?.length > 0) {
        const ar = booking?.arrestReports[0];
        if (isNonEmptyVariable(ar?.scheduledReleaseDate)) {
          releaseDateTime = dayjs(
            `${ar?.scheduledReleaseDate} ${ar?.scheduledReleaseTime || ""}`
          );
        }
      }

      setFormData({
        scheduledReleaseOverridden:
          booking?.arrestReports?.[0]?.scheduledReleaseOverridden,
        releaseOfficerStaffId:
          booking?.arrestReports?.[0]?.releaseOfficerStaffId,
        releaseReasonId: booking?.arrestReports?.[0]?.releaseReasonId,
        totalDaysInCustody: booking?.arrestReports?.[0]?.totalDaysInCustody,
        releaseWarCheckDate: booking?.arrestReports?.[0]
          ?.arrestReportsExtra?.[0]?.releaseWarCheckDate
          ? dayjs(
              booking?.arrestReports?.[0]?.arrestReportsExtra?.[0]
                ?.releaseWarCheckDate
            )
          : null,
        scheduledReleaseDateTime: releaseDateTime,
        releasedDateTime: isNonEmptyVariable(
          booking?.arrestReports?.[0]?.releaseDate
        )
          ? dayjs(
              `${booking?.arrestReports?.[0]?.releaseDate || ""} ${
                booking?.arrestReports?.[0]?.releaseTime || ""
              }`
            )
          : null,
        releaseToAuthorityId: booking?.arrestReports?.[0]?.releaseToAuthorityId,
        releaseToFacilityId: booking?.arrestReports?.[0]?.releaseToFacilityId,
        releaseToState: booking?.arrestReports?.[0]?.releaseToState,
      });
    } else {
      setFormData(null);
    }
  }, [booking]);

  useEffect(() => {
    if (booking?.releaseNotes) {
      setReleaseNotesList(
        booking.releaseNotes.map((item) => ({ ...item }))
      );
    }
  }, [booking?.releaseNotes]);

  useEffect(() => {
    if (formData !== null) {
      form?.setFieldsValue(formData);
    } else {
      form?.resetFields();
    }
  }, [formData]);

  // useEffect(() => {
  //   updateReleaseNotes();
  // }, [releaseNotesList]);

  useEffect(() => {
    releaseNotesForm?.setFieldsValue(selectedReleaseNotes);
  }, [selectedReleaseNotes]);

  const clickAddModalAction = () => {
    setShowAddModal(!showAddModal);
    setSelectedReleaseNotes(null);
    setIsRowSelected(false);
    setIsEdit(false);
  };

  const saveReleaseNts = () => {
    releaseNotesForm.validateFields().then((values) => {
      const updatedList = releaseNoteID
        ? releaseNotesList.map((p) =>
            p.releaseNoteID === releaseNoteID || p.id === releaseNoteID
              ? { ...values, releaseNoteID }
              : p
          )
        : [...releaseNotesList, { ...values, id: uuidv4() }];

      setReleaseNotesList(updatedList);

      dispatch(
        setBookings({
          releaseNotes: updatedList,
        })
      );

      clickAddModalAction();
    });
  };

  const QFormDataSave = () => {
    QForm.validateFields().then((values) => {
      const updatedList = [
        ...releaseNotesList,
        { ...values, id: uuidv4() },
      ];

      setReleaseNotesList(updatedList);

      dispatch(
        setBookings({
          releaseNotes: updatedList,
        })
      );

      QForm.resetFields();
    });
  };

  const patchSelectedRow = (editData) => {
    const selectedNotes = {
      releaseNote: editData?.releaseNote,
      comments: editData?.comments,
      cleared: editData?.cleared === "Yes" ? true : false,
      clearanceNotes: editData?.clearanceNotes,
      clearanceDateTime: editData?.clearanceDate
        ? dayjs(editData?.clearanceDate + " " + editData?.clearanceTime)
        : null,
      clearedByStaffID: editData?.clearedByStaffID,
    };
    releaseNotesForm.setFieldsValue(selectedNotes);
    setReleaseNoteID(editData?.releaseNoteID || editData?.id);
    setSelectedReleaseNotes(selectedNotes);
    setIsRowSelected(true);
  };

  const addNewNotes = () => {
    setReleaseNoteID(null);
    releaseNotesForm.setFieldsValue({
      releaseNote: "",
      comments: "",
      cleared: false,
      clearanceNotes: "",
      clearanceDateTime: null,
      clearedByStaffID: null,
    });
    setSelectedReleaseNotes(null);
    setIsRowSelected(false);
    clickAddModalAction();
  };

  const deleteReleaseNotes = () => {
    if (!releaseNoteID) return;

    // 1️⃣ Prepare updated list (IMMUTABLE)
    const updatedList = releaseNotesList.filter(
      (item) =>
        item?.releaseNoteID !== releaseNoteID &&
        item?.id !== releaseNoteID
    );

    // 2️⃣ Update local UI immediately
    setReleaseNotesList(updatedList);

    // 3️⃣ Update Redux booking
    dispatch(
      setBookings({
        releaseNotes: updatedList,
      })
    );

    // 4️⃣ Call / queue delete API
    const url = `${API_ENDPOINTS.releaseInformation}/id/${releaseNoteID}`;
    dispatch(setDeleteAPis(url));

    // 5️⃣ Reset selection state
    setReleaseNoteID(null);
    setIsRowSelected(false);
    setSelectedReleaseNotes({
      releaseNote: "",
      comments: "",
      cleared: false,
      clearanceNotes: "",
      clearanceDateTime: null,
      clearedByStaffID: null,
    });
  };

  const updateForm = (data) => {
    dispatch(
      setBookings({
        arrestReports: [
          {
            ...booking?.arrestReports?.[0],
            ...data,
            arrestReportsExtra: [
              {
                ...booking?.arrestReports?.[0]?.arrestReportsExtra?.[0],
                releaseWarCheckDate: data.releaseWarCheckDate || null,
              },
            ],
          },
        ],
      })
    );
  };

  const updateReleaseNotes = () => {
    if (
      isNonEmptyVariable(releaseNotesList) &&
      releaseNotesList?.length !== 0
    ) {
      dispatch(
        setBookings({
          releaseNotes: [...releaseNotesList],
        })
      );
    } else {
      dispatch(
        setBookings({
          releaseNotes: [],
        })
      );
    }
  };

  const dataModify = debounce(() => {
    const values = form.getFieldsValue();
    setOverrideDateTime(values?.scheduledReleaseOverridden);
    values.scheduledReleaseDateTime = values?.scheduledReleaseDateTime
      ? dayjs(values?.scheduledReleaseDateTime)?.format("MM/DD/YYYY HH:mm")
      : null;

    values.releasedDateTime = values?.releasedDateTime
      ? dayjs(values?.releasedDateTime)?.format("MM/DD/YYYY HH:mm")
      : null;

    const data = {
      ...values,
      scheduledReleaseDate: values?.scheduledReleaseDateTime?.split(" ")[0],
      scheduledReleaseTime: values?.scheduledReleaseDateTime?.split(" ")[1],
      releaseDate: values?.releasedDateTime?.split(" ")[0],
      releaseTime: values?.releasedDateTime?.split(" ")[1],
      releaseWarCheckDate: values?.releaseWarCheckDate
        ? dayjs(values?.releaseWarCheckDate).format("MM/DD/YYYY")
        : null,
    };

    delete data?.scheduledReleaseDateTime;
    delete data?.releasedDateTime;

    updateForm(data);
  }, 600);
  useEffect(() => {
    if (isEdit) {
      let isShow = hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.subModule,
        LABELS_CAPITAL.MODIFY,
        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
        SUB_MODULES_LIST_WITH_ID.Arrest_Report
      );
      if (isShow) {
        setIsDisabled(false);
      } else {
        setIsDisabled(true);
      }
    } else {
      setIsDisabled(false);
    }
  }, [isEdit]);
  console.log(form.getFieldsValue(), "release form values");
  return (
    <>
      <Form
        form={form}
        initialValues={formData}
        disabled={!bookingsFieldsEnabled}
        onFieldsChange={() => {
          dataModify();
        }}
      >
        <StyledSectionHeading marginTop="-10px" marginBottom="0px">
          <span>Release Information</span>
        </StyledSectionHeading>
        <StyledGridRow justify="end">
          <StyledGridCol>
            <FormItem
              name="scheduledReleaseOverridden"
              valuePropName="checked"
              label="Override release date?"
              layout="horizontal"
              labelPostion="label-right"
            >
              <Checkbox
                id="isOverridereleaseDate"
                name="isOverridereleaseDate"
              />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
        <StyledGridRow gutter={16}>
          <StyledGridCol lg={8}>
            <FormItem
              label="Scheduled Release Date And Time"
              name="scheduledReleaseDateTime"
              disabled={!overrideDateTime}
            >
              <CommonDatePicker
                format="MM/DD/YYYY hh:mm"
                disabled={!overrideDateTime}
                placeholder="Select Date and Time"
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <FormItem label="Release Date And Time" name="releasedDateTime">
              <CommonDatePicker
                disableFutureDates={true}
                format="MM/DD/YYYY HH:mm"
                placeholder="Select Date and Time"
                disabled={!bookingsFieldsEnabled}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={5}>
            <FormItem label="Released By" name="releaseOfficerStaffId">
              <Select
                id="RI-ReleasedBy"
                options={getOptionsFromRefList("", true, false, true)}
                placeholder="Released By"
                showSearch={true}
                variant="outlined"
                disabled={!bookingsFieldsEnabled}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <FormItem label="Release Reason" name="releaseReasonId">
              <Select
                id="RI-ReleaseReason"
                options={getOptionsFromRefList(
                  "ChargeClearance",
                  false,
                  false,
                  true
                )}
                onChange={() => {
                  form.setFieldValue("releaseToAuthorityId", null);
                  form.setFieldValue("releaseToFacilityId", null);
                  form.setFieldValue("releaseToState", null);
                }}
                placeholder="Release Reason"
                showSearch={true}
                variant="outlined"
                disabled={!bookingsFieldsEnabled}
              />
              {console.log(
                getOptionsFromRefList("Release_Reason", false, false, true),
                "options"
              )}
            </FormItem>
          </StyledGridCol>
          {formData?.releaseReasonId == 54240015 && (
            <StyledGridCol lg={6}>
              <FormItem
                label="Release to (Authority)"
                name="releaseToAuthorityId"
              >
                <Select
                  id="RI-ReleaseToAuthorityId"
                  options={getOptionsFromRefList(
                    "Release_to_Authority",
                    false,
                    false,
                    true
                  )}
                  placeholder="Release Reason"
                  showSearch={true}
                  variant="outlined"
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
          )}
          {formData?.releaseReasonId == 54240016 && (
            <StyledGridCol>
              <FormItem
                label="Release to (Facility) "
                name="releaseToFacilityId"
              >
                <Select
                  id="RI-ReleaseToFacilityId"
                  options={getOptionsFromRefList(
                    "Release_to_Facility",
                    false,
                    false,
                    true
                  )}
                  placeholder="Release Reason"
                  showSearch={true}
                  variant="outlined"
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
          )}
          {formData?.releaseReasonId == 54240017 && (
            <StyledGridCol>
              <FormItem label="Release to (State)" name="releaseToState">
                <Select
                  id="RI-ReleaseToState"
                  options={getOptionsFromRefList("USState")}
                  placeholder="Release Reason"
                  showSearch={true}
                  variant="outlined"
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
          )}
          <StyledGridCol>
            <FormItem
              label="Days Confined for Current Detention"
              name="totalDaysInCustody"
            >
              <TextField id="RI-DaysConfinedCurrentDetention" disabled />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol>
            <FormItem label="Release War Check Date" name="releaseWarCheckDate">
              <CommonDatePicker
                format="MM/DD/YYYY"
                placeholder="MM/DD/YYYY"
                showTime={false}
                disabled={!bookingsFieldsEnabled}
              />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
      </Form>
      <StyledSectionHeading>
        <span>Release Notes</span>
      </StyledSectionHeading>
      <Form
        form={QForm}
        initialValues={QFormData}
        disabled={!bookingsFieldsEnabled}
        onFieldsChange={() => {
          setIsQFormBtnEnable(QForm.getFieldValue()?.releaseNote?.length === 0);
        }}
      >
        <StyledGridRow gutter={16}>
          <StyledGridCol span={8}>
            <FormItem label="Release Note" name="releaseNote">
              <TextField id="RI-QAdd-ReleaseNote" />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol span={8}>
            <FormItem label="Comments" name="comments">
              <TextField id="RI-QAdd-Comments" />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol>
            <StyledFlex
              align="center"
              style={{ height: "100%", paddingTop: "10px" }}
            >
              <Button
                color="primary"
                type="primary"
                onClick={() => QFormDataSave()}
                disabled={
                  !bookingsFieldsEnabled ||
                  isQFormBtnEnable ||
                  !hasCheckSecurity(
                    Security_Types.functionality,
                    Entity_types.subModule,
                    LABELS_CAPITAL.ADD,
                    MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                    SUB_MODULES_LIST_WITH_ID.Arrest_Report
                  )
                }
              >
                Q-ADD
              </Button>
            </StyledFlex>
          </StyledGridCol>
        </StyledGridRow>
      </Form>
      <InmateDetailsTableContainer>
        <TableHeader>
          <div></div>
          <div>
            <Button
              color="primary"
              type="primary"
              onClick={() => addNewNotes()}
              disabled={
                !bookingsFieldsEnabled ||
                !hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.ADD,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Arrest_Report
                )
              }
            >
              Add
            </Button>

            { <Button
              color="primary"
              type="primary"
              disabled={
                !isRowSelected ||
                !hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.VIEW,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Arrest_Report
                )
              }
              style={{ marginLeft: "15px" }}
              onClick={() => {
                setShowAddModal(true);
                setIsEdit(true);
              }}
            >
              Details
            </Button> }
            <Popconfirm
              title="Delete the Release Information"
              description="Are you sure to delete this Release Information?"
              onConfirm={deleteReleaseNotes}
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
            >
              <Button
                color="primary"
                type="primary"
                style={{ marginLeft: "10px" }}
                disabled={
                  !bookingsFieldsEnabled ||
                  !isRowSelected ||
                  releaseNotesList?.length === 0 ||
                  !hasCheckSecurity(
                    Security_Types.functionality,
                    Entity_types.subModule,
                    LABELS_CAPITAL.DELETE,
                    MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                    SUB_MODULES_LIST_WITH_ID.Arrest_Report
                  )
                }
              >
                Delete
              </Button>
            </Popconfirm>
          </div>
        </TableHeader>

        {hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.VIEW,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Arrest_Report
        ) && (
          <Table
            headers={releaseNotesTable.headers}
            data={
              releaseNotesList?.map((item) => {
                return { ...item, cleared: item?.cleared ? "Yes" : "No" };
              }) || []
            }
            onRowClick={(data) => patchSelectedRow(data)}
            onRowDoubleClick={(data) => {
              patchSelectedRow(data);
              setShowAddModal(true);
              setIsEdit(true); 
            }}
            selected={selectedReleaseNotes === null}
            // variant="outlined"
          />
        )}
      </InmateDetailsTableContainer>

      <Modal
        header="Add Release Note"
        show={showAddModal}
        onHide={clickAddModalAction}
        footerActions={[
          {
            key: "save",
            text: "Save",
            onClick: saveReleaseNts,
            disabled: isDisabled || !bookingsFieldsEnabled,
          },
        ]}
        footerCloseAction={() => setIsEdit(false)}
        footerCloseActionText="Cancel"
      >
        <Form form={releaseNotesForm} initialValues={selectedReleaseNotes}>
          <StyledGridRow>
            <StyledGridCol span={24}>
              <FormItem
                label="Release Note"
                name="releaseNote"
                required={!fullSearch}
                rules={
                  !fullSearch
                  ? [
                    {
                      required: true,
                      message: "Release Note is required",
                    },
                  ] : []
                }
              >
                <TextField disabled={!bookingsFieldsEnabled} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={24}>
              <FormItem label="Comment" name="comments">
                <TextField inputType="textarea" disabled={!bookingsFieldsEnabled} />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>

          <StyledSectionHeading>
            <span>Clearance Information</span>
          </StyledSectionHeading>

          <StyledGridRow gutter={16}>
            <StyledGridCol span={24}>
              <FormItem
                name="cleared"
                label="Cleared ?"
                valuePropName="checked"
                layout="horizontal"
                className="form-item-checkbox-left"
              >
                <Checkbox
                  id="release-notes-cleared"
                  name="cleared"
                  checked={selectedReleaseNotes?.cleared}
                  onChange={(event) => {
                    setSelectedReleaseNotes((prev) => ({
                      releaseNote:releaseNotesForm.getFieldValue("releaseNote"),
                      comments: releaseNotesForm.getFieldValue("comments"),
                      clearedByStaffID: currentUser?.staffId,
                      clearanceNotes: null,
                      clearanceDateTime: dayjs(new Date()),
                      cleared: event.target.checked,
                    }));
                  }}
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>

            {selectedReleaseNotes?.cleared && (
              <>
                <StyledGridCol span={12}>
                  <FormItem label="Date / Time" name="clearanceDateTime">
                    <CommonDatePicker format="MM/DD/YYYY hh:mm" disabled={!bookingsFieldsEnabled} />
                  </FormItem>
                </StyledGridCol>
                <StyledGridCol span={12}>
                  <FormItem label="Cleared By" name="clearedByStaffID">
                    <Select
                      options={getOptionsFromRefList("", true, false, true)}
                      placeholder="Cleared By"
                      showSearch={true}
                      variant="outlined"
                      onChange={(e) => {
                        setTimeout(() => document.activeElement.blur(), 0);
                      }}
                      disabled={!bookingsFieldsEnabled}
                    />
                  </FormItem>
                </StyledGridCol>
                <StyledGridCol span={24}>
                  <FormItem label="Clearance Notes" name="clearanceNotes">
                    <TextField inputType="textarea" disabled={!bookingsFieldsEnabled} />
                  </FormItem>
                </StyledGridCol>
              </>
            )}
          </StyledGridRow>
        </Form>
      </Modal>
    </>
  );
};

export default BoookingsReleaseInformation;
